"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTranslateModal = void 0;
const sound_notify_mp3_1 = __importDefault(require("assets/sound-notify.mp3"));
const models_hook_1 = require("app/models.hook");
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const copilotApi_1 = require("@/schemaComponents/modules/copilotApi");
const copilot_1 = require("@/schemaComponents/modules/copilot");
const standard_1 = require("react-hook-schema/standard");
const wordTable_1 = require("@/schemaComponents/modules/hooks/wordTable");
const updateScript_1 = require("@/utils/updateScript");
const reportTokenUsage_1 = require("@/utils/reportTokenUsage");
const helpers_1 = require("./helpers");
require("./style.scss");
const TranslateAllModal = ({ onResolve, scripts, closeModal, projectId, segmentId, langId, }) => {
    const [soundNotify, setSoundNotify] = (0, react_1.useState)(false);
    const audioRef = (0, react_1.useRef)(null);
    const [completedTranslations, setCompletedTranslations] = (0, react_1.useState)(0);
    const scriptsNeedingTranslation = (0, react_1.useMemo)(() => scripts.filter((script) => { var _a; return !((_a = script.translations) === null || _a === void 0 ? void 0 : _a[langId]); }), [scripts, langId]);
    const completed = (0, react_1.useMemo)(() => completedTranslations === scriptsNeedingTranslation.length, [completedTranslations, scriptsNeedingTranslation.length]);
    // Replace custom keyboard handler with the hook
    const handleEnter = (0, react_1.useCallback)(() => {
        if (completed) {
            onResolve(false);
        }
    }, [completed, onResolve]);
    const handleEscape = (0, react_1.useCallback)(() => {
        if (completed) {
            onResolve(false);
        }
        else {
            onResolve(false);
            closeModal();
        }
    }, [completed, onResolve, closeModal]);
    (0, standard_1.useKeyboardShortcuts)(handleEnter, handleEscape);
    (0, react_1.useEffect)(() => {
        if (audioRef.current) {
            if (completed && soundNotify) {
                audioRef.current.play();
            }
        }
    }, [soundNotify, audioRef.current, completed]);
    // Handle translate
    const model = (0, copilotApi_1.getCopilotSetting)().translationModel;
    const searchFromProject = (0, wordTable_1.useProjectWordTable)(projectId);
    const searchFromSegmentTable = (0, wordTable_1.useScriptBasedWordTable)(projectId, segmentId);
    const { data: projectData } = (0, models_hook_1.useProjectDoc)({ projectId });
    const searchFromPrevScripts = (0, wordTable_1.usePrevScripts)(projectId, segmentId, langId);
    const [errorScripts, setErrorScripts] = (0, react_1.useState)([]);
    const handleTranslate = (script, controller) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c, _d, _e, _f;
        const textValue = script.text || "";
        const context = yield (0, copilot_1.getContextPromise)({
            searchFromProject,
            searchFromSegmentTable,
            langId,
            projectId,
            schema: projectData,
            textValue,
            searchFromPrevScripts: searchFromPrevScripts === null || searchFromPrevScripts === void 0 ? void 0 : searchFromPrevScripts(script.scriptId),
            controller,
        });
        if (context.scripts) {
            const matchedContext = context.scripts.find((c) => c.translation && c.text && c.text === textValue);
            if (matchedContext && matchedContext.translation) {
                return matchedContext.translation;
            }
        }
        // eslint-disable-next-line no-useless-catch
        try {
            const responsePromise = yield (0, copilotApi_1.chatCompletionWithContext)({
                stream: false,
                model,
                context: (_a = context.scripts) !== null && _a !== void 0 ? _a : [],
                controller,
                prompt: Object.assign(Object.assign({}, copilotApi_1.defaultTranslationPrompt), projectData === null || projectData === void 0 ? void 0 : projectData.translationPrompt),
                params: {
                    langId,
                    text: textValue,
                    precedingText: "",
                },
            });
            if (!responsePromise.ok) {
                throw new helpers_1.ChatCompletionError(responsePromise);
            }
            const data = yield responsePromise.json();
            // Check for content filter issue
            if (((_c = (_b = data.choices) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.finish_reason) === "content_filter") {
                throw new helpers_1.ChatCompletionError(new Response(null, {
                    status: 400,
                    statusText: "Content Filter",
                }));
            }
            // トークン使用量を報告
            if (data.usage) {
                (0, reportTokenUsage_1.reportTokenUsage)(model !== null && model !== void 0 ? model : "unknown", data.usage.prompt_tokens, data.usage.completion_tokens, projectId).catch(console.error);
            }
            return (_f = (_e = (_d = data.choices) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.message) === null || _f === void 0 ? void 0 : _f.content;
        }
        catch (error) {
            throw error;
        }
    });
    const handleSaveScript = (translatedScript, isCountCompleted = true) => {
        if (isCountCompleted) {
            setCompletedTranslations((c) => c + 1);
        }
        (0, updateScript_1.updateScript)({
            projectId,
            segmentId,
            scriptId: translatedScript.scriptId,
            data: translatedScript,
        });
    };
    const handleAddErrorScript = (script) => {
        // If the error is a retryable error, add it to the error list after exceeding the retry limit
        if (script.error && helpers_1.RETRY_ERROR_TYPE.includes(script.error)) {
            setErrorScripts((prev) => [...prev, script]);
            if (script.retryCount && script.retryCount > helpers_1.MAX_RETRY_COUNT) {
                setCompletedTranslations((c) => c + 1);
                if (script.error === "RATE_LIMIT") {
                    // Because limit rate is an general error
                    // so after max retry, remove the rate limit script from error list
                    // to hide it from the error list
                    setErrorScripts((prev) => prev.filter((s) => s.scriptId !== script.scriptId));
                }
            }
        }
        else {
            setCompletedTranslations((c) => c + 1);
            setErrorScripts((prev) => [...prev, script]);
        }
    };
    (0, react_1.useEffect)(() => {
        const abortController = new AbortController();
        (() => __awaiter(void 0, void 0, void 0, function* () {
            const scriptsWithExistingTranslations = scripts.filter((script) => { var _a, _b; return ((_a = script.translations) === null || _a === void 0 ? void 0 : _a[langId]) && !((_b = script.translationStatus) === null || _b === void 0 ? void 0 : _b[langId]); });
            scriptsWithExistingTranslations.forEach((script) => {
                const translatedScript = Object.assign(Object.assign({}, script), { translationStatus: Object.assign(Object.assign({}, (script.translationStatus || {})), { [langId]: "translated" }) });
                handleSaveScript(translatedScript, false);
            });
            if (scriptsNeedingTranslation.length > 0) {
                yield (0, helpers_1.translateAll)({
                    scripts: scriptsNeedingTranslation,
                    langId,
                    translate: handleTranslate,
                    save: handleSaveScript,
                    addError: handleAddErrorScript,
                    controller: abortController,
                });
            }
        }))();
        return () => {
            abortController.abort();
        };
    }, []);
    const rateLimitErrors = (0, react_1.useMemo)(() => errorScripts.filter((s) => s.error === "RATE_LIMIT"), [errorScripts]);
    const latestTimeToTwait = (0, react_1.useMemo)(() => {
        if (rateLimitErrors.length === 0) {
            return 0;
        }
        const latestError = rateLimitErrors[rateLimitErrors.length - 1];
        return latestError.timeToWait || 0;
    }, [errorScripts]);
    const otherErrors = (0, react_1.useMemo)(() => errorScripts.filter((s) => s.error !== "RATE_LIMIT"), [errorScripts]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_bootstrap_1.Modal, { show: true },
            react_1.default.createElement(react_bootstrap_1.Modal.Header, { className: "d-flex flex-column align-items-start" },
                react_1.default.createElement(react_bootstrap_1.Modal.Title, null, "\u4E00\u62EC\u7FFB\u8A33"),
                react_1.default.createElement("p", null, "\u30BF\u30D6\u3092\u30A2\u30AF\u30C6\u30A3\u30D6\u306B\u3057\u3001\u4ED6\u306E\u30A6\u30A3\u30F3\u30C9\u30A6\u3084\u30BF\u30D6\u306E\u4E0B\u306B\u96A0\u3055\u306A\u3044\u3067\u7DAD\u6301\u3057\u3066\u304F\u3060\u3055\u3044\u3002"),
                react_1.default.createElement(react_bootstrap_1.Form.Check, { label: "\u4E00\u62EC\u7FFB\u8A33\u5B8C\u4E86\u6642\u306B\u97F3\u3092\u9CF4\u3089\u3059", defaultChecked: soundNotify, onChange: (e) => setSoundNotify(e.target.checked) })),
            react_1.default.createElement(react_bootstrap_1.Modal.Body, null,
                completed ? (react_1.default.createElement(react_1.default.Fragment, null, "\u7FFB\u8A33\u5B8C\u4E86")) : (react_1.default.createElement(react_1.default.Fragment, null,
                    "\u7FFB\u8A33\u4E2D: ",
                    completedTranslations,
                    " /",
                    " ",
                    scriptsNeedingTranslation.length)),
                errorScripts.length > 0 && (react_1.default.createElement("div", { style: {
                        borderTop: "solid 1px #ccc",
                        marginTop: 12,
                        paddingTop: 12,
                    } },
                    react_1.default.createElement("b", null, "\u30A8\u30E9\u30FC\u4E00\u89A7:"),
                    react_1.default.createElement("div", { style: { maxHeight: 400, overflowY: "scroll", paddingTop: 12 } },
                        otherErrors.map((script, index) => {
                            var _a, _b;
                            return (react_1.default.createElement("div", { key: `${script.scriptId}_${index}` },
                                react_1.default.createElement("p", null,
                                    "ID: ",
                                    script.scriptId),
                                react_1.default.createElement("p", null,
                                    "\u30BF\u30A4\u30D7: ",
                                    script.scriptType),
                                react_1.default.createElement("p", null,
                                    "\u30C6\u30AD\u30B9\u30C8: ",
                                    script.text),
                                react_1.default.createElement("p", null,
                                    "\u30AD\u30E3\u30F3\u30BB\u30EB\u7406\u7531:",
                                    " ", (_b = helpers_1.ErrorMessage[(_a = script.error) !== null && _a !== void 0 ? _a : ""]) !== null && _b !== void 0 ? _b : script.error),
                                react_1.default.createElement("hr", null)));
                        }),
                        rateLimitErrors.length > 0 && (react_1.default.createElement("p", null,
                            "Open AI\u306E\u30AF\u30AA\u30FC\u30BF\u5236\u9650\u306E\u305F\u3081\u3001",
                            react_1.default.createElement(Countdown, { seconds: latestTimeToTwait, key: rateLimitErrors.length }),
                            " ",
                            "\u79D2\u5F85\u6A5F\u3057\u3066\u304B\u3089\u518D\u958B\u3057\u307E\u3059")))))),
            react_1.default.createElement(react_bootstrap_1.Modal.Footer, null, completed ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(react_bootstrap_1.Button, { variant: "secondary", onClick: () => {
                        onResolve(false);
                    } }, "OK"))) : (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(react_bootstrap_1.Button, { onClick: () => {
                        onResolve(false);
                        closeModal();
                    } }, "\u7FFB\u8A33\u4E2D\u6B62"))))),
        react_1.default.createElement("div", { className: completed ? "flashing" : "" }),
        react_1.default.createElement("audio", { src: sound_notify_mp3_1.default, ref: audioRef })));
};
const useTranslateModal = () => (0, standard_1.useModalWithRegister)(TranslateAllModal);
exports.useTranslateModal = useTranslateModal;
const Countdown = ({ seconds }) => {
    const [count, setCount] = (0, react_1.useState)(seconds);
    (0, react_1.useEffect)(() => {
        const timer = setInterval(() => {
            setCount((prevCount) => prevCount - 1);
        }, 1000);
        if (count === 0) {
            clearInterval(timer);
        }
        return () => {
            clearInterval(timer);
        };
    }, []);
    return count < 0 ? null : react_1.default.createElement("span", null, count);
};
